export const getIsAuthError = state => state.error?.includes('code 401');
